import { JSX } from "react";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";

import { Typography } from "@mui/material";

function ErrorPage(): JSX.Element {
	const { t } = useTranslation();

	return (
		<>
			<Typography variant="h1">{t("pageNotFound")}</Typography>
			<Typography variant="body1">{t("invalidPage")}</Typography>
			<Link to="/">{t("goHome")}</Link>
		</>
	);
}

export default ErrorPage;
